import { currentSkuIdForProductSelector, upgradeProductSelector } from '../../../selectors/ProductsSelectors';
import { Flex } from 'foundations-components/components/Flex';
import { useSelector } from 'react-redux';
import UIContactSalesButton from 'ui-addon-upgrades/button/UIContactSalesButton';
import { APP } from '../../../constants/tracking/App';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export const TalkToSalesFallback = ({
  apiName,
  skuId,
  screen,
  trackingSource
}) => {
  const isAppReady = useGlobalLoading();
  const isAppAuth = useSelector(isAppAuthSelector);
  const resolvedSkuId = useSelector(state => {
    if (!isAppReady) return null;
    return apiName ? currentSkuIdForProductSelector(state, {
      apiName
    }) : skuId;
  });
  const upgradeProduct = useSelector(state => upgradeProductSelector(state, {
    skuIds: resolvedSkuId ? [resolvedSkuId] : []
  }));
  const upgradeData = {
    app: APP,
    screen,
    uniqueId: `${trackingSource}-${upgradeProduct}`,
    upgradeProduct,
    apiName
  };
  if (!resolvedSkuId || !isAppAuth) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    alignItems: "stretch",
    children: /*#__PURE__*/_jsx(UIContactSalesButton, {
      upgradeData: upgradeData,
      use: "primary",
      block: true
    })
  });
};